export default __webpack_public_path__ + "static/media/element_26.8b5f4227.avif";